export default __webpack_public_path__ + "static/media/regulatory--turn-right-ahead--g2.7774ded9.png";